import { render, staticRenderFns } from "./ComplaintsSamplesTable.vue?vue&type=template&id=2ccae418"
import script from "./ComplaintsSamplesTable.vue?vue&type=script&lang=js"
export * from "./ComplaintsSamplesTable.vue?vue&type=script&lang=js"
import style0 from "./ComplaintsSamplesTable.vue?vue&type=style&index=0&id=2ccae418&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports